/**
 * Spend threshold auto gift: adds variant when eligible cart subtotal exceeds threshold.
 */
(function () {
  const THRESHOLD_CENTS = 40000;
  const GIFT_VARIANT_ID = 39802245218353;
  const GIFT_PROPERTY_KEY = '_auto_threshold_gift';
  const GIFT_PROPERTY_VALUE = 'true';

  let syncing = false;

  function routes() {
    const r = (window.themeVariables && window.themeVariables.routes) || {};
    const root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return {
      cartUrl: r.cartUrl || root + 'cart',
      cartAddUrl: (r.cartAddUrl || root + 'cart/add') + '.js',
      cartChangeUrl: (r.cartChangeUrl || root + 'cart/change') + '.js'
    };
  }

  function eligibleSubtotalCents(cart) {
    if (!cart || !cart.items) return 0;
    return cart.items.reduce(function (sum, item) {
      if (Number(item.variant_id) === GIFT_VARIANT_ID) return sum;
      return sum + (item.final_line_price || item.line_price || 0);
    }, 0);
  }

  function findAutoGiftLine(cart) {
    if (!cart || !cart.items) return null;
    return (
      cart.items.find(function (item) {
        if (Number(item.variant_id) !== GIFT_VARIANT_ID) return false;
        const props = item.properties || {};
        return props[GIFT_PROPERTY_KEY] === GIFT_PROPERTY_VALUE;
      }) || null
    );
  }

  function findAnyGiftLine(cart) {
    if (!cart || !cart.items) return null;
    return cart.items.find(function (item) {
      return Number(item.variant_id) === GIFT_VARIANT_ID;
    });
  }

  async function fetchCartJson() {
    const res = await fetch(routes().cartUrl + '.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Could not load cart');
    return res.json();
  }

  async function refreshCartUi(changeResponse) {
    const cartContent = await fetchCartJson();
    cartContent.sections = changeResponse && changeResponse.sections;

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cart: cartContent, fromThresholdGift: true }
      })
    );

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: {
          cart: cartContent,
          openMiniCart: false,
          fromThresholdGift: true
        }
      })
    );
  }

  async function addGiftLine() {
    const res = await fetch(routes().cartAddUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: GIFT_VARIANT_ID,
        quantity: 1,
        properties: {
          [GIFT_PROPERTY_KEY]: GIFT_PROPERTY_VALUE
        },
        sections: ['mini-cart'],
        sections_url: window.location.pathname
      })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || 'Could not add gift');
    return data;
  }

  async function removeGiftLine(lineKey) {
    const res = await fetch(routes().cartChangeUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: 0,
        sections: ['mini-cart'],
        sections_url: window.location.pathname
      })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || 'Could not remove gift');
    return data;
  }

  async function syncThresholdGift(cart) {
    if (syncing) return;
    if (!cart) {
      try {
        cart = await fetchCartJson();
      } catch (e) {
        console.error('[Threshold gift]', e.message);
        return;
      }
    }

    const subtotal = eligibleSubtotalCents(cart);
    const meetsThreshold = subtotal >= THRESHOLD_CENTS;
    const autoGiftLine = findAutoGiftLine(cart);
    const anyGiftLine = findAnyGiftLine(cart);

    if (meetsThreshold && !anyGiftLine) {
      syncing = true;
      try {
        const response = await addGiftLine();
        await refreshCartUi(response);
      } catch (e) {
        console.error('[Threshold gift]', e.message);
      } finally {
        syncing = false;
      }
      return;
    }

    if (!meetsThreshold && autoGiftLine) {
      syncing = true;
      try {
        const response = await removeGiftLine(autoGiftLine.key);
        await refreshCartUi(response);
      } catch (e) {
        console.error('[Threshold gift]', e.message);
      } finally {
        syncing = false;
      }
    }
  }

  document.documentElement.addEventListener('cart:updated', function (event) {
    if (event.detail && event.detail.fromThresholdGift) return;
    syncThresholdGift(event.detail && event.detail.cart);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncThresholdGift();
    });
  } else {
    syncThresholdGift();
  }
})();
